export default function useScrollToTop(id = 'mui-scoped-baseline', behavior: ScrollBehavior = 'smooth') {
	const scroll = () => {
		const doScroll = () => {
			// Resolve container at scroll time (after layout updates)
			const container = typeof document === 'undefined' ? null : document.getElementById(id);
			// Prefer container scroll if it is actually scrollable
			if (container && container.scrollHeight > container.clientHeight) {
				try {
					container.scrollTo({ top: 0, behavior });
				} catch {
					container.scrollTop = 0;
				}
				return;
			}
			// Fallback: scroll the window
			try {
				window.scrollTo({ top: 0, behavior });
			} catch {
				window.scrollTo(0, 0);
			}
		};
		// Defer to next frame; tiny timeout helps real iOS devices after state updates
		requestAnimationFrame(() => setTimeout(doScroll, 0));
	};
	return scroll;
}
